<template>
  <!-- 弹窗 -->
  <el-dialog
    :title="setTitle"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="innerdialog_list" v-if="dialogVisible">
      <iframe
        :src="textSrc"
        ref="iframe"
        frameborder="0"
        width="100%"
        height="270px"
        scrolling="no"
        @load="submitTip"
      ></iframe>
    </div>
    <div>
      <small
        >单个文件大小限制{{
          sizeLimit
        }}M以内，显示文件名称后，点击下方【确认上传】即可完成上传</small
      >
    </div>
    <!-- 上传 -->
    <span slot="footer" class="dialog-footer">
      <el-button :loading="showLoading" @click="handleClose">返回</el-button>
      <el-button v-if="showSubmit" type="primary" @click="sureUpload"
        >确认上传</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      iframeWin: {},
      dialogVisible: false,
      fileList: [],
      selectIndex: "",
      showSubmit: false,
      showLoading: false,
      textSrc: "",
    };
  },

  computed: {
    setTitle() {
      return "文件上传";
    },
    sizeLimit() {
      if (this.selectIndex == 3) {
        return "1000";
      }
      return "1000";
    },
  },
  mounted() {
    this.textSrc = "./static/test.html?v=" + new Date().getTime();
    let that = this;
    window.addEventListener("message", function (event) {
      const data = event.data;
      console.log(3333, data);
      if (data.start) {
        that.showLoading = true;
        that.showSubmit = false;
      } else {
        that.showLoading = false;
        that.showSubmit = true;
      }
      if (data.delete) {
        that.fileList.length = 0;
      }
      if (data.videoURL) {
        that.fileList[0] = {
          url: data.videoURL,
          name: data.name,
        };
      }
    });
  },
  methods: {
    //确认上传
    sureUpload() {
      if (!this.fileList.length) {
        this.dialogVisible = false;
        return;
      }
      this.$message({
        message: "添加成功",
        type: "success",
      });
      this.$emit("submitSuccess", this.fileList);
      this.dialogVisible = false;
      setTimeout(() => {
        this.fileList = [];
      });
    },
    showAdd(params) {
      if (params.index) {
        this.selectIndex = params.index;
      }
      this.dialogVisible = true;
      setTimeout(() => {
        this.$nextTick(() => {
          this.iframeWin = this.$refs.iframe.contentWindow;
        });
      });
    },
    handleClose() {
      if (this.showLoading) {
        this.$message.error("正在上传中，请耐心等待上传...");
        return;
      }
      if (this.fileList.length) {
        setTimeout(() => {
          this.fileList = [];
        });
      }
      this.dialogVisible = false;
    },
    submitTip() {
      this.iframeWin.postMessage({
        params: {
          //根据那你的Bucket地点来填写，例如：oss-cn-beijing
          region: "oss-cn-hangzhou",
          // 自己账户的accessKeyId
          accessKeyId: "LTAI5t7u8eECWfr85YSz7RXF",
          //自己账户的accessKeySecret
          accessKeySecret: "zpLQSoug2qGGmKwn4Y1XlmKspBYGiq",
          // bucket名字  桶名称
          bucket: "ng-association-system",
          index: this.selectIndex,
        },
      });
    },
  },
};
</script>

<style scoped="scoped">
.el-dialog__header {
  height: 100px;
  line-height: 100px;
}

.el-dialog__body {
  padding: 10px 20px;
}

>>> .el-dialog {
  border-radius: 6px;
}

/* 模板下载 */
.mubanDown {
  display: flex;
  height: 40px;
  line-height: 40px;
  justify-content: space-between;
  align-items: center;
}

.mubanDown button {
  cursor: pointer;
  width: 80px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #1890ff;
  font-size: 12px;
  background-color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1890ff;
}

.innerdialog_list {
  padding-top: 20px;
  display: flex;
  /* height: 40px; */
  align-items: flex-start;
  line-height: 40px;
  align-content: flex-start;
  margin-bottom: 10px;
  border-bottom: 1px solid #b5b5b5;
}

/* .innerdialog_list p {
		
	} */
.listP {
  font-size: 14px;
  width: 80px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
}

.innerdialog_list span {
  display: block;
  font-size: 12px;
  width: 40px;
  margin-left: 20px;
  height: 20px;
  line-height: 20px;
  background: #ffffff;
  text-align: center;
  border: 1px solid #1890ff;
  cursor: pointer;
}

.list_center {
  width: 310px;
  min-height: 40px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}

/* 每个上传文件的样式 */
.inner_upload {
  position: relative;
  min-height: 40px;
  margin: 0 10px;
  /* width: 100px; */
  /* overflow: scroll; */
}

.inner_upload p {
  color: #1890ff;
}

.inner_upload img {
  border-radius: 50%;
  position: absolute;
  right: 0;
  top: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

/* 保存提示 */
.tipList p {
  line-height: 25px;
  text-align: left;
}

.tipList p:first-child {
  margin-bottom: 20px;
}
</style>
